import React, { useEffect } from 'react';
import { TokenType, useAuth } from '../../contexts';
import { handleRoleNavigation, Loading } from '../../components';
import { useNavigate } from 'react-router-dom';

export const SSOHome: React.FunctionComponent = () => {
  const { user, setCurrentRole, getSSOUser, logout } = useAuth();

  const [loading, setLoading] = React.useState(true);
  const navigation = useNavigate();

  /**
   * Set a timeout to show the loading screen for 1 second
   */
  useEffect(() => {
    setTimeout(() => {
      setLoading(false);
    }, 1000);
  }, []);

  /**
   * Get the SSO user and navigate to the correct page
   */
  useEffect(() => {
    // if there is already a user, navigate to the correct page
    if (user) {
      if (user.tokenType === TokenType.GUEST) {
        logout();
        return;
      }
      setCurrentRole(user.role[0]);
      handleRoleNavigation(user.role[0]);
      return;
    }

    // if there is no user, get the SSO user
    // note: applicant should not visit this page
    void getSSOUser().catch(() => {
      // if there is an error, navigate to the login page
      console.error('Unauthorized user attempt. Please login.');
      navigation('/login');
    });
  }, [user?.role]);

  /**
   * Show the loading screen
   */
  return loading ? (
    <Loading />
  ) : (
    <p>Please refresh this page if waiting too long.</p>
  );
};
